// extracted by mini-css-extract-plugin
export default {"watermark":"WaterMark_watermark__YBK-L"};